import React from 'react';
import { Box } from '@chakra-ui/react';
import { CAREER_START_YEAR, SENIOR_PROMOTION_YEAR } from '../data/experience';
import SectionHeading from './section-heading';
import Timeline from './timeline';

export default function Experiences() {
  const experiencesList = [
    {
      duration: `${SENIOR_PROMOTION_YEAR} – Present`,
      badge: 'Current',
      current: true,
      title: 'Senior Software Developer',
      subtitle: 'Metamedia Technology Co., Ltd.',
    },
    {
      duration: `${CAREER_START_YEAR} – ${SENIOR_PROMOTION_YEAR}`,
      title: 'Software Developer',
      subtitle: 'Metamedia Technology Co., Ltd.',
    },
    {
      duration: '2020',
      title: 'Web Developer Internship',
      subtitle: 'Unixdev Co., Ltd',
    },
  ];

  return (
    <Box mt={'90px'}>
      <SectionHeading index="03">Experiences</SectionHeading>
      <Timeline items={experiencesList} />
    </Box>
  );
}
